import "../views/blocks";
import "../views/layout";
import "../views/ui";
import "../views/woo";
import "./js";

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    // Array.from(document.querySelectorAll("[data-tracking]")).forEach((el) =>
    //   el.addEventListener("click", () => {
    //     // @ts-ignore
    //     console.log("dataLayer", dataLayer);
    //   })
    // );
  },
  {
    once: true,
  }
);
